import { render, staticRenderFns } from "./fullScreenExpense.vue?vue&type=template&id=6642b4c9&scoped=true&"
import script from "./fullScreenExpense.vue?vue&type=script&lang=js&"
export * from "./fullScreenExpense.vue?vue&type=script&lang=js&"
import style0 from "./fullScreenExpense.vue?vue&type=style&index=0&id=6642b4c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6642b4c9",
  null
  
)

export default component.exports